module.exports = __webpack_public_path__ + "static/media/Gilroy-Bold.17cb9303.otf";